import { render, staticRenderFns } from "./registerUser.vue?vue&type=template&id=358e5e28&scoped=true"
import script from "./registerUser.vue?vue&type=script&lang=js"
export * from "./registerUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358e5e28",
  null
  
)

export default component.exports